<template>
  <div class="tswrapper">
    <div class="tscontent">
      <div class="tsbox" v-for="(item,index) in newsData" :key="index">
        <h3 @click="$router.push(`/infoContent/${item.id}`)">{{item.name}}</h3>
        <div class="tstime">
          <p>时间 : {{item.magtime}}</p>
          <p>浏览量 : {{item.magcount}}</p>
        </div>
      </div>
    </div>
    <div class="tspage" v-if="paginations.total>paginations.page_size">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="paginations.page_index"
        :page-size="paginations.page_size"
        :total="paginations.total"
        layout="prev, pager, next"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
import { getInfo } from "@/api/news.js";
import { BASE_URL } from "@/utils/base.js";
export default {
  data() {
    return {
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
      },
      newsData: []
    };
  },
  props: {
    fenlei: {
      type: String
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getData();
  },
  methods: {
    async getData() {
      let news = new FormData();
      news.append("page", this.paginations.page_index);
      news.append("rows", this.paginations.page_size);
      news.append("dentity", this.fenlei);
      let note = await getInfo(news);
      this.paginations.total = note.total;
      this.newsData = note.rows;
      this.newsData.map(item => {
        item.magtime = item.magtime.substring(0,10)
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val;
      this.getData();
    }
  },
  components: {}
};
</script>
<style lang="less" scoped>
.tswrapper {
  width: 90%;
  margin: 30px auto;
  .tscontent {
    width: 100%;
    .tsbox {
      width: 100%;
      border-bottom: dotted 1px #ededed;
      h3 {
        margin-top: 30px;
        font-size: 16px;
        width: 640px;
        color: #000;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow:ellipsis;
        &:hover {
          text-decoration: underline;
        }
      }
      .tstime {
        margin: 20px 0;
        display: flex;
        justify-content: space-between;
        p {
          font-size: 14px;
          color: #3b3b3b;
        }
      }
    }
  }
  .tspage {
    margin: 70px 0 90px;
    text-align: center;
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #fd7a3a;
      border: none;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
      background-color: #fff; // 进行修改未选中背景和字体
      border: 1px solid #ededed;
      // color: #fff;
    }
    /deep/ .el-pagination.is-background button {
      background-color: #fff; // 进行修改未选中背景和字体
      border: 1px solid #ededed;
      // color: #fff;
    }
  }
}
</style>